var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlook24X24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.639 7.26v3.22l1.175.708c.03.009.098.01.129 0l5.056-3.264c0-.386-.376-.663-.588-.663h-5.772Z",
    fill: "#0B0204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.639 11.68 1.072.706c.151.106.333 0 .333 0C14.863 12.492 20 9.225 20 9.225v5.916c0 .645-.43.915-.915.915h-5.447V11.68ZM8.087 10.197c-.365 0-.657.164-.872.492-.215.329-.322.763-.322 1.304 0 .549.107.983.322 1.302.215.32.497.478.846.478.36 0 .645-.155.855-.465.21-.31.317-.741.317-1.292 0-.574-.102-1.021-.307-1.34-.205-.32-.484-.48-.84-.48Z",
    fill: "#0B0204"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.626V18.22l10.006 2.009V3.77L3 5.626Zm6.696 8.426c-.423.533-.974.8-1.655.8a1.989 1.989 0 0 1-1.62-.775c-.417-.517-.626-1.19-.626-2.018 0-.876.211-1.585.636-2.126.424-.54.985-.811 1.684-.811.66 0 1.195.258 1.603.776.408.518.612 1.2.612 2.048 0 .87-.212 1.573-.634 2.106Z",
    fill: "#0B0204"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook24X24);
export default __webpack_public_path__ + "static/media/outlook-24x24.b4ada3ec0c3d2fcb7a85abcfaf813d97.svg";
export { ForwardRef as ReactComponent };